import { ProductWarrantyUpsertModel } from './bulk-add-warranty.model';

export class ProductWarrantyUpsertArrayModel {
    productWarrantyArray: ProductWarrantyUpsertModel[];
}
